import React from 'react';
import { Link } from 'gatsby';
import ContentLayout from '../../components/ContentLayout';
import props from '../../lib/contentLayoutProps/learning-at-kingston/layoutProps';
import { getNavItem } from '../../lib/nav';

import styles from './index.module.scss';

import image from '../../../static/kingston-difference@large.jpg';
import early from './early@large.jpg';
import primary from './primary@large.jpg';

const rootNavItem = getNavItem(...props.rootNavKey);

/* eslint-disable react/prop-types */
export default () => (
  <ContentLayout {...props} locale="en" image={image} showNav={false} showBreadcrumbs={false} pageKey="">
    <h1>Learning at Kingston</h1>
    <p>
      Kingston International School offers an IB-PYP bilingual (English/Putonghua) programme for students aged 1 to 11
      years of age. Kingston has three campuses - the Kindergarten and Children's Centre which houses our early years
      programme for children 1 to 4 years of age, a Lower Primary campus for students from Year 1 to Year 3 and an Upper
      Primary campus for students from Year 4 to Year 6. Although we have three campuses we are still a small school
      with a community feel. We maintain small class sizes and have an English and a Putonghua class teacher for each
      class.
    </p>
    <div className={styles.campuses}>
      <Link
        className={styles.campus}
        to={`/en${rootNavItem.items[0].uri}`}
        style={{ backgroundImage: `url(${early})` }}
      >
        <div className={styles.text}>Kingston Early Years</div>
      </Link>
      <Link
        className={styles.campus}
        to={`/en${rootNavItem.items[1].uri}`}
        style={{ backgroundImage: `url(${primary})` }}
      >
        <div className={styles.text}>Kingston Primary School</div>
      </Link>
      <Link className={styles.campus} to={`/en${rootNavItem.items[2].uri}`}>
        <div className={styles.text}>ICHK Secondary School</div>
      </Link>
    </div>
  </ContentLayout>
);
